import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '@auth/app/core/services/auth.service';

/** Injeta `Authorization: Bearer` — exceto em endpoints públicos de autenticação. */
export const authTokenInterceptor: HttpInterceptorFn = (req, next) => {
  if (
    req.url.includes('/auth/tenant/sign-in') ||
    req.url.includes('/users/forgot-password') ||
    req.url.includes('/users/change-temporary-password')
  ) {
    return next(req);
  }

  const token = inject(AuthService).getAccessToken();

  if (!token) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    }),
  );
};
